import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import "./Transactions.css";

const MonthlyReportSummary = () => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [transactionsRes, schedulesRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/transactions/allTransactions`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API_BASE_URL}/schedules/all`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const transactions = transactionsRes.data || [];
        const schedules = schedulesRes.data || [];

        const dataMap = {};

        // Group transactions
        for (const tx of transactions) {
          if (tx.status !== "Completed") continue;
          const date = new Date(tx.date);
          const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
          if (!dataMap[key]) {
            dataMap[key] = { newPurchases: 0, revenue: 0, sessionsCompleted: 0 };
          }
          dataMap[key].newPurchases += 1;
          dataMap[key].revenue += Number(tx.amount || 0);
        }

        // Group schedules
        for (const session of schedules) {
          const date = new Date(session.date);
          if (!date || isNaN(date)) continue;
          if (new Date(session.date) > new Date()) continue; // only past dates are considered completed

          const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
          if (!dataMap[key]) {
            dataMap[key] = { newPurchases: 0, revenue: 0, sessionsCompleted: 0 };
          }
          dataMap[key].sessionsCompleted += 1;
        }

        const formatted = Object.entries(dataMap)
          .map(([key, value]) => {
            const [year, month] = key.split("-");
            const date = new Date(`${year}-${month}-01`);
            const monthLabel = date.toLocaleString("default", { month: "long", year: "numeric" });
            const avgOrderValue = value.newPurchases
              ? Math.round(value.revenue / value.newPurchases)
              : 0;
            return {
              month: monthLabel,
              ...value,
              avgOrderValue,
            };
          })
          .sort((a, b) => new Date(b.month) - new Date(a.month)) // recent first
          .slice(0, 2); // only last 2 months

        setSummary(formatted);
      } catch (error) {
        console.error("Failed to fetch summary data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="dashboard-wrapper">
      <div className="sidebar-fixed">
        <Sidebar />
      </div>

      <div className="dashboard-main">
        <Navbar />
        <div className="transaction-content">
          <div className="table-container">
            <div className="table-header">
              <h4 className="section-title">📈 Monthly Report Summary</h4>
            </div>

            {loading ? (
              <p>Loading summary...</p>
            ) : (
              <div className="table-scroll-wrapper">
                <table className="transactions-table">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th>New Purchases</th>
                      <th>Sessions Completed</th>
                      <th>Revenue</th>
                      <th>Avg. Order Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.month}</td>
                        <td>{row.newPurchases}</td>
                        <td>{row.sessionsCompleted}</td>
                        <td>${row.revenue.toLocaleString()}</td>
                        <td>${row.avgOrderValue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyReportSummary;
